export class GridColumns {
    static readonly SOLAR_PROVIDER = ['Bussiness name', 'email', 'phone number', 'number of solar products', 'status', 'view details'];
}